import { createActionGroup, props } from '@ngrx/store';
import { ManagedApplication } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// CONTAINER ACTIONS
// ============================================================================

export const ManagedApplicationsContainerActions = createActionGroup({
  source: 'Managed Application Container',
  events: {
    'Managed Application Requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const ManagedApplicationsApiActions = createActionGroup({
  source: 'Apple Device API',
  events: {
    'Managed Applications Loaded': props<{ managedApplications: ManagedApplication[] }>(),
    'Managed Applications Loaded Error': props<{ error: ErrorModel }>(),
  },
});
